import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { AdminReviewerBookEditResponse } from '../../responses/platform/admin-reviewer-book-edit.response';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { AdminReviewerBookEditRequest } from '../../requests/platform/admin-reviewer-edit.request';

@Injectable({
  providedIn: 'root'
})

export class AdminReviewerEditService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  getBookPublishEdit(idBookVersion: number): Observable<AdminReviewerBookEditResponse> {
    // Troque pelo endpoint real do seu backend
    return this.http.get<AdminReviewerBookEditResponse>(`${environment.urlApiPlatform}AdminReviewerBook/idBookVersion/${idBookVersion}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
  
  approveReview(request: AdminReviewerBookEditRequest): Observable<AdminReviewerBookEditResponse> {
    // Troque pelo endpoint real do seu backend
    return this.http.post<AdminReviewerBookEditResponse>(`${environment.urlApiPlatform}AdminReviewerBook/approve`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  rejectReview(request: AdminReviewerBookEditRequest): Observable<AdminReviewerBookEditResponse> {
    // Troque pelo endpoint real do seu backend
    return this.http.post<AdminReviewerBookEditResponse>(`${environment.urlApiPlatform}AdminReviewerBook/reject`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  saveForLater(request: AdminReviewerBookEditRequest): Observable<AdminReviewerBookEditResponse> {
    // Troque pelo endpoint real do seu backend
    return this.http.post<AdminReviewerBookEditResponse>(`${environment.urlApiPlatform}AdminReviewerBook/SaveForLater`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}

